module.exports = __webpack_public_path__ + "static/media/object-group.c3da5f69.svg";